module.exports = __webpack_public_path__ + "img/step4a-mobile-en@2x.4f43f02b.webp";